/**
 * BeezFy Drawer System - VERSIONE FINALE FUNZIONANTE
 * Sistema definitivo per la gestione dei drawer
 */

// Make BeezfyDrawerSystem globally available
window.BeezfyDrawerSystem = (function() {
  'use strict';

  class BeezfyDrawerSystem {
    constructor() {
      this.drawers = new Map();
      this.activeDrawer = null;
      this.overlay = null;
      this.isAnimating = false;
      this.scrollPosition = 0;

      // Integrazione col tasto INDIETRO. Ogni apertura aggiunge una voce di cronologia "finta"
      // sulla stessa URL: così il back (fisico su Android, e quello dell'app) chiude il pannello
      // invece di portare via dalla pagina, e tornando indietro da una scheda prodotto aperta
      // dal pannello lo ritroviamo aperto. Escluso il filtro: gestisce già la cronologia da sé.
      this.historyKey = 'bzDrawer';
      this.historyDrawers = ['wishlist', 'cart', 'search', 'account'];
      this.pushedState = false;

      this.init();
    }

    init() {
      // Wait for DOM if needed
      if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', () => this.setup());
      } else {
        this.setup();
      }
    }

    setup() {

      // Create overlay
      this.createOverlay();

      // Register all drawers
      this.registerDrawers();

      // Setup event listeners
      this.setupEventListeners();

      // Pannello da riaprire? (ritorno "indietro" su questa pagina)
      this.restoreFromHistory();
    }

    createOverlay() {
      if (this.overlay) return;

      this.overlay = document.createElement('div');
      this.overlay.className = 'beezfy-drawer-overlay';
      this.overlay.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        background: rgba(0, 0, 0, 0.5);
        z-index: 9005;
        display: none;
        opacity: 0;
        transition: opacity 0.3s ease;
      `;
      document.body.appendChild(this.overlay);

      this.overlay.addEventListener('click', () => {
        this.closeActiveDrawer();
      });

    }

    registerDrawers() {
      const drawerElements = document.querySelectorAll('[data-beezfy-drawer]');

      drawerElements.forEach(drawer => {
        const type = drawer.dataset.beezfyDrawer;

        // Ensure drawer is hidden initially (remove aria-hidden)
        drawer.removeAttribute('aria-hidden');
        drawer.style.display = 'none';
        drawer.classList.remove('active');

        // Add necessary styles if missing (only if not already styled)
        const hasStyles = drawer.style.position || drawer.classList.contains('beezfy-drawer');

        if (!hasStyles) {
          drawer.style.position = 'fixed';
          drawer.style.top = '0';
          drawer.style.height = '100%';
          drawer.style.zIndex = '9010';
          drawer.style.backgroundColor = '#fff';
          drawer.style.transition = 'transform 0.3s cubic-bezier(0.4, 0, 0.2, 1)';

          // Position based on type
          if (drawer.dataset.position === 'left' || type === 'menu') {
            drawer.style.left = '0';
            drawer.style.transform = 'translateX(-100%)';
          } else {
            drawer.style.right = '0';
            drawer.style.transform = 'translateX(100%)';
          }
        }

        this.drawers.set(type, drawer);
      });
    }

    setupEventListeners() {
      // Click on triggers
      document.addEventListener('click', (e) => {
        const trigger = e.target.closest('[data-drawer-trigger]');
        if (trigger) {
          e.preventDefault();
          e.stopPropagation();

          const drawerType = trigger.dataset.drawerTrigger;
          this.openDrawer(drawerType);
        }

        // Close buttons
        const closeBtn = e.target.closest('[data-drawer-close]');
        if (closeBtn) {
          e.preventDefault();
          e.stopPropagation();
          this.closeActiveDrawer();
        }
      });

      // Escape key
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.activeDrawer) {
          this.closeActiveDrawer();
        }
      });

      // Tasto indietro: consuma la voce finta e chiude il pannello aperto.
      window.addEventListener('popstate', () => {
        if (this.activeDrawer) {
          this.pushedState = false;
          this.forceClose();
        }
      });

      // Ritorno su questa pagina dallo snapshot del browser (o della WebView dell'app):
      // gli script non ripartono, quindi il ripristino va rifatto qui.
      window.addEventListener('pageshow', (e) => {
        if (e.persisted) this.restoreFromHistory();
      });
    }

    // Aggiunge (o aggiorna) la voce di cronologia finta associata al pannello aperto
    pushHistory(type) {
      if (this.historyDrawers.indexOf(type) === -1) return;
      if (!window.history || !window.history.pushState) return;
      try {
        const state = {};
        state[this.historyKey] = type;
        if (this.pushedState) {
          window.history.replaceState(state, '', window.location.href);
        } else {
          window.history.pushState(state, '', window.location.href);
          this.pushedState = true;
        }
      } catch (err) { /* cronologia non disponibile: il pannello funziona lo stesso */ }
    }

    // Riapre il pannello che risulta aperto nello stato di cronologia corrente
    restoreFromHistory() {
      if (this.activeDrawer) return;
      const state = window.history && window.history.state;
      const type = state && state[this.historyKey];
      if (!type || !this.drawers.has(type)) return;
      this.pushedState = true; // la voce finta è già in cronologia: non va ri-aggiunta
      this.openDrawer(type, { skipHistory: true });
    }

    openDrawer(type, options) {
      if (this.isAnimating) {
        return;
      }

      const drawer = this.drawers.get(type);
      if (!drawer) {
        console.error(`[BeezfyDrawerSystem] Drawer "${type}" not found`);
        return;
      }

      this.isAnimating = true;

      // Close any active drawer
      if (this.activeDrawer && this.activeDrawer !== type) {
        this.closeDrawer(this.activeDrawer, false);
      }

      // Show overlay
      this.overlay.style.display = 'block';
      requestAnimationFrame(() => {
        this.overlay.style.opacity = '1';
      });

      // Show drawer (remove aria-hidden BEFORE display block)
      drawer.removeAttribute('aria-hidden');
      drawer.style.display = 'block';

      // Se è il carrello, aggiorna con il sistema appropriato
      if (type === 'cart') {
        if (window.BeezfyCart) {
          window.BeezfyCart.refresh();
        } else if (window.bfyCart) {
          window.bfyCart.refreshCart();
        }
      }

      // Trigger reflow
      drawer.offsetHeight;

      // Animate in
      requestAnimationFrame(() => {
        drawer.style.transform = 'translateX(0)';
        drawer.classList.add('active');
      });

      this.activeDrawer = type;

      if (!options || !options.skipHistory) this.pushHistory(type);

      // Lock scroll - Mobile optimized
      this.scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      document.body.classList.add('panel-open');
      document.body.style.top = `-${this.scrollPosition}px`;

      // Special actions for specific drawers
      if (type === 'cart') {
        this.updateCart();
      }

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);

      // Emit event for other systems
      document.dispatchEvent(new CustomEvent('drawer:opened', {
        detail: { type, drawer }
      }));
    }

    closeDrawer(type, hideOverlay = true) {
      const drawer = this.drawers.get(type);
      if (!drawer) return;


      // Animate out
      const position = drawer.dataset.position || 'right';
      if (position === 'left') {
        drawer.style.transform = 'translateX(-100%)';
      } else {
        drawer.style.transform = 'translateX(100%)';
      }
      drawer.classList.remove('active');

      // Hide after animation (don't use aria-hidden)
      setTimeout(() => {
        drawer.style.display = 'none';
        // Move focus back to trigger if it exists
        const trigger = document.querySelector(`[data-drawer-trigger="${type}"]`);
        if (trigger) {
          trigger.focus();
        }
        // Emit event for other systems
        document.dispatchEvent(new CustomEvent('drawer:closed', {
          detail: { type, drawer }
        }));
      }, 300);

      if (hideOverlay) {
        this.overlay.style.opacity = '0';
        setTimeout(() => {
          this.overlay.style.display = 'none';
        }, 300);

        // Unlock scroll and restore position - Mobile optimized
        document.body.classList.remove('panel-open');
        document.body.style.top = '';
        window.scrollTo(0, this.scrollPosition);
        this.scrollPosition = 0;
      }
    }

    closeActiveDrawer() {
      if (!this.activeDrawer || this.isAnimating) return;

      if (this.pushedState) {
        // Chiudiamo tornando indietro di una voce: così la cronologia resta pulita e il tasto
        // Indietro successivo esce davvero dalla pagina invece di "non fare niente".
        this.pushedState = false;
        try {
          window.history.back();
          // Rete di sicurezza: se il popstate non arriva (cronologia manipolata da altro),
          // chiudiamo comunque.
          setTimeout(() => { if (this.activeDrawer) this.forceClose(); }, 350);
          return;
        } catch (err) { /* prosegue con la chiusura diretta */ }
      }

      this.forceClose();
    }

    forceClose() {
      if (!this.activeDrawer || this.isAnimating) return;

      this.isAnimating = true;

      this.closeDrawer(this.activeDrawer);
      this.activeDrawer = null;

      setTimeout(() => {
        this.isAnimating = false;
      }, 300);
    }

    // Cart specific methods
    async updateCart() {

      try {
        const response = await fetch('/cart.js');
        const cart = await response.json();

        // DISABILITATO - USA bfy-cart.js che genera HTML corretto
        // NON generare HTML qui - lascia che bfy-cart.js gestisca tutto
        return; // Esci subito senza modificare l'HTML

        // Update cart count
        const countElements = document.querySelectorAll('[data-cart-count]');
        countElements.forEach(el => {
          el.textContent = cart.item_count;
        });

      } catch (error) {
        console.error('[BeezfyDrawerSystem] Error updating cart:', error);
      }
    }

    formatMoney(cents) {
      return '€' + (cents / 100).toFixed(2);
    }
  }

  // Return the class
  return BeezfyDrawerSystem;
})();

// Initialize when ready

function initializeSystem() {
  if (window.beezfyDrawerSystem) {
    return;
  }

  window.beezfyDrawerSystem = new window.BeezfyDrawerSystem();

  // Also expose for backward compatibility
  window.beezfyDrawer = window.beezfyDrawerSystem;
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeSystem);
} else {
  initializeSystem();
}
